<div>
                <app-navbar></app-navbar>
                <router-outlet class=""></router-outlet>
</div>

 



